import { name, version } from '../package.json';

export default {
    active: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets the item to active.',
        },
    },
    disabled: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets thhe item to disabled.',
        },
    },
    href: {
        type: String,
        docs: {
            validation: '—',
            description: 'When provided, makes the list group item `a`-based and sets the `href` path.',
        },
    },
    iconLeft: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the item icon.',
        },
    },
    image: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the item image.',
        },
    },
    imageRound: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, makes the item image round.',
        },
    },
    metadata: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the item metadata.',
            support: ['v-html'],
        },
    },
    metadataBelow: {
        type: Array,
        docs: {
            validation: '—',
            description: 'Sets the item metadata below.',
            support: ['v-html'],
        },
    },
    microcopy: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the item microcopy.',
        },
    },
    separatorBefore: {
        type: Boolean,
        default: false,
        docs: {
            validation: 'Only use within a sublist.',
            description: 'If `true`, adds a separator above the item.',
        },
    },
    sublist: {
        type: Boolean,
        docs: {
            validation: '',
            description: 'If `true`, item should wrap another list group to creates a sublist.',
        },
    },
    text: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'Sets the item text.',
        },
    },
    toggleActive: {
        type: Boolean,
        default: false,
        docs: {
            validation: 'Only use on an item with `sublist` set to `true`.',
            description: 'If `true`, expands the sublist.',
            support: ['v-model'],
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
